import {
  supportAnalyticsInputSchema,
  supportAnalyticsOutputSchema,
  type SupportAnalyticsOutput,
} from "@redotech/redo-support-common/support/analytics/support-analytics-schemas";
import { unaryRpc } from "@redotech/rpc/definition";

function isoDay(daysAgo: number): string {
  const date = new Date();
  date.setUTCDate(date.getUTCDate() - daysAgo);
  return date.toISOString().slice(0, 10);
}

function withDayLabels<T extends { label: string }>(segments: T[]): T[] {
  return segments.map((segment, index) => ({
    ...segment,
    label: isoDay(segments.length - 1 - index),
  }));
}

function withDayRange<T extends { start: string; end: string }>(
  points: T[],
): T[] {
  return points.map((point, index) => {
    const day = isoDay(points.length - 1 - index);
    return { ...point, start: day, end: day };
  });
}

export const supportAnalytics = unaryRpc({
  name: "supportAnalytics" as const,
  input: supportAnalyticsInputSchema,
  output: supportAnalyticsOutputSchema,
  // Generated label/start/end strings are words. Charts parse them as YYYY-MM-DD.
  mock: (generated: SupportAnalyticsOutput) => ({
    ...generated,
    conversationsBySegment: withDayLabels(generated.conversationsBySegment),
    ticketVolumeLookback: generated.ticketVolumeLookback
      ? withDayLabels(generated.ticketVolumeLookback)
      : undefined,
    responseTimeLookback: generated.responseTimeLookback
      ? withDayRange(generated.responseTimeLookback)
      : undefined,
    aiVsHumanLookback: generated.aiVsHumanLookback
      ? withDayRange(generated.aiVsHumanLookback)
      : undefined,
  }),
});
